import { trackSearchResultsFacetClickEvent } from '@sitecore-search/data';
import FacetChangedActionHandler from './FacetChangedActionHandler.js';
export default class RangeActionHandler extends FacetChangedActionHandler {
    process(rfkId, query, payload) {
        const { facetId, min, max, facetIndex, silentTracking } = payload;
        query.getRequest().resetSearchFacetTypeFilter(facetId);
        if (typeof min !== 'undefined' || typeof max !== 'undefined') {
            query.getRequest().addSearchFacetTypeFilter(facetId, { value: min, type: 'gte' }, 'and');
            query.getRequest().addSearchFacetTypeFilter(facetId, { value: max, type: 'lte' }, 'and');
            const { facetTitle } = this.getCurrentFacetInfo(query, payload);
            if (!silentTracking) {
                trackSearchResultsFacetClickEvent(rfkId, query.getRequest().getEntity(), {
                    filters: [
                        {
                            facetId,
                            ...(typeof min !== 'undefined' ? { startValue: min.toString() } : {}),
                            ...(typeof max !== 'undefined' ? { endValue: max.toString() } : {}),
                            // Reviewed with data team, is fine to send it like that.
                            facetValue: `${min} - ${max}`,
                            // @TODO: review if worth to send this
                            valueIndex: 0,
                            facetIndex,
                            facetTitle,
                        },
                    ],
                });
            }
        }
    }
}
